import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeftRounded = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 24, viewBox: "0 0 14 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 2L2 12L12 22", stroke: "#5777DA", strokeWidth: 4, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrowLeftRounded);
export { ForwardRef as ReactComponent };
